module.exports = __webpack_public_path__ + "media/images/stripe-logo-icon-d1c0f8547472cff54b72001289c8e584.svg";